import { FC } from 'react';
import { Button, Card, Col, Form, Row } from "antd";
import * as React from "react";

import SelectPublishField from '../fields/select-publish-field';
import { useSearchParams } from 'react-router-dom';
import SelectUsersField from '../fields/select-user-field';
import SelectUnitField from '../fields/select-unit-field';
import SelectTransactionActionField from '../fields/select-transaction-action-field';

interface Prop {
	onFinish: (data: any) => any
}

const TransactionFilter: FC<Prop> = ({ onFinish }) => {
	const [form] = Form.useForm();
	const [searchParams] = useSearchParams()

	React.useEffect(() => {
		form.setFieldValue("user", searchParams.get("user"))
		form.setFieldValue("unit", searchParams.get("unit"))
		form.setFieldValue("action", searchParams.get("action"))
		onFinish(form.getFieldsValue())
	}, [])

	return (
		<Card style={{ marginBottom: "16px" }}>
			<Form form={form} onFinish={onFinish} layout="horizontal"  autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="user" label="کاربر">
							<SelectUsersField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="unit" label="واحد" 	>
							<SelectUnitField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="action" label="عملیات" 	>
							<SelectTransactionActionField allowClear />
						</Form.Item>
					</Col>

					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">جستجو</Button>
					</Col>
				</Row>
			</Form>
		</Card>
	)
}

export default TransactionFilter;
